import styled from 'styled-components';

import { colorPrimary50 } from '@/styleUtils';

export const Option = styled.label`
  display: block;
`;

export const OptionInput = styled.input`
  display: none;
`;

export const OptionLabel = styled.span`
  cursor: pointer;
  display: block;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  margin: 0;
  overflow: hidden;
  padding: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;

  &:hover,
  &.focus-visible {
    background-color: ${colorPrimary50};
  }

  input:checked + & {
    background-color: ${colorPrimary50};
    position: relative;
  }
`;
